import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  &:not(:last-child) {\n    width: 100%;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    height: 4px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  z-index: -1;\n  width: 100%;\n  height: 6px;\n  background-color: ", ";\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  transform: none;\n  top: 35px;\n  right: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  transform: none;\n  top: 35px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  white-space: pre;\n  display: block;\n  position: absolute;\n  top: 35px;\n  transform: translateX(-50%);\n  font-size: ", ";\n  letter-spacing: 2%;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  box-shadow: 0 0 0 4px #c2c2c2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 12px;\n    height: 12px;\n    border: 6px solid ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  border: 10px solid ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled, media } from "@styles";
export var Dot = styled.div(_templateObject(), function (props) {
  return props.done ? "#f76268" : "#c2c2c2";
}, media.xMediumScreen(_templateObject2(), function (props) {
  return props.done ? "#f76268" : "#c2c2c2";
}));
export var ActiveDot = styled.div(_templateObject3());
export var Label = styled.span(_templateObject4(), [function (props) {
  return props.theme.typography.smallFontSize;
}], function (props) {
  return props.theme.colors.baseFontColorSemiTransparent;
});
export var LeftLabel = styled(Label)(_templateObject5());
export var RightLabel = styled(Label)(_templateObject6());
export var ProgressBar = styled.div(_templateObject7(), function (props) {
  return props.done ? "#f76268" : "#c2c2c2";
}, media.xMediumScreen(_templateObject8()));
export var Step = styled.div(_templateObject9());
export var Wrapper = styled.div(_templateObject10());